import { render, staticRenderFns } from "./CuentasCobroFacturaciones.vue?vue&type=template&id=505dbd62"
import script from "./CuentasCobroFacturaciones.vue?vue&type=script&lang=js"
export * from "./CuentasCobroFacturaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports